// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.LMSearch .el-form-item--mini.el-form-item,\n.LMSearch .el-form-item--small.el-form-item {\n  margin-bottom: 0;\n}\n.LMSearch .el-form-item__label .searchNumberType .el-input__inner {\n  border: 0;\n  font-weight: bold;\n  padding: 0;\n}\n.el-table .primary {\n  color: #00A551;\n}\n.el-table .danger {\n  color: #f56c6c;\n}\n", ""]);
// Exports
module.exports = exports;
